// extracted by css-extract-rspack-plugin
export default {"root":"_vO2BT","expanded-grid":"lTBsmV","expandedGrid":"lTBsmV","card":"rWQyU7"};